import '@/js/dist/www.iichi.com/common';

import { createApp, h } from 'vue';
import { uniq } from '@/js/lib/helper/array';
import { pinia } from '@/js/lib/store';
import { useEventStore } from '@/js/lib/store/event';
import FilterSort from '@/js/components/event/filter-sort.vue';
import EventLikeButtonSmall from '@/js/components/www.iichi.com/organisms/eventLikeButtonSmall.vue';

const eventStore = useEventStore(pinia);

document.addEventListener('DOMContentLoaded', () => {
  const filterSortEl = document.querySelector('filter-sort') as HTMLElement;
  createApp({
    render: () =>
      h(FilterSort, {
        initialPeriod: filterSortEl.dataset.initialPeriod || undefined,
        initialGenres: JSON.parse(filterSortEl.dataset.initialGenres!) as string[],
        initialPrefecture: filterSortEl.dataset.initialPrefecture || undefined,
        initialSort: filterSortEl.dataset.initialSort,
      }),
  }).mount(filterSortEl);

  const eventButtonEls: NodeListOf<HTMLElement> = document.querySelectorAll('event-like-button-small');
  if (eventButtonEls.length > 0) {
    const eventIds = Array.from(eventButtonEls, (el) => Number(el.dataset.eventId));
    eventStore.initLikedData(uniq(eventIds));
    eventButtonEls.forEach((el) => {
      createApp({
        render: () =>
          h(EventLikeButtonSmall, {
            eventId: Number(el.dataset.eventId),
          }),
      }).mount(el);
    });
  }
});
